export const required = value => (value ? undefined : 'is Required');
export const maxLength = max => value =>
  value && value.length > max ? `Must be ${max} characters or less` : undefined;
export const maxLength30 = maxLength(30);
export const minLength = min => value =>
  value && value.length < min ? `Must be ${min} characters or more` : undefined;
export const minLength2 = minLength(2);
export const number = value =>
  value && isNaN(Number(value)) ? 'Must be a number' : undefined;
export const minValue = min => value =>
  value && value < min ? `Must be at least ${min}` : undefined;
export const phoneNumber = value =>
  value && !/^(0|[1-9][0-9]{9})$/i.test(value)
    ? 'Invalid phone number, must be 10 digits'
    : undefined;

   


export const validatePassword = (password) => {
  let uppercase = "ABCDEFGHIJKLMNOPQRSTUVWXYZ";
  let lowercase = "abcdefghijklmnopqrstuvwxyz";
  let digits = "0123456789";
  let splChars = "!@#$%^&*";

  let upperCaseFlag = check(password, uppercase);
  let lowerCaseFlag = check(password, lowercase);
  let digitsFlag = check(password, digits);
  let splCharsFlag = check(password, splChars);

  let totalFlag = upperCaseFlag + lowerCaseFlag + digitsFlag + splCharsFlag;

  if (password.length >= 12 && totalFlag >= 2) {
    return true;
  } else {
    // toastr.error(
    //   "Password must be between 12-20 characters</br>Must satisfy any two of four category</br>1.Contains Uppercase Alphabet(A-Z)</br>2.Contains Lowercase Alphabet(a-z)</br>3.Contains digits(0-9)</br>4.Contains splChars(!@#$%^&*)"
    // );
    return false;
  }
};

const check = (password, allowedChars) => {
  for (let i = 0; i < password.length; i++) {
    let char = password.charAt(i);
    if (allowedChars.indexOf(char) >= 0) {
      return 1;
    }      
  }
  return 0;
};



// WEBPACK FOOTER //
// ./src/utils/validate.js